// extracted by mini-css-extract-plugin
export default {"shareButton__icon":"PlaylistShareButton_shareButton__icon__Y-PAG","shimmer":"PlaylistShareButton_shimmer__jJuS2"};